import type { CaCompositionBucket } from "@/lib/reporting.api";
import { formatTransactionCount, formatXaf } from "../services.formatters";
import { ServiceHighlightCard } from "./ServiceHighlightCard";

export function ServicesHighlightsGrid({
  topByVolume,
  topByGain,
}: {
  topByVolume?: CaCompositionBucket;
  topByGain?: CaCompositionBucket;
}) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
      <ServiceHighlightCard
        title="Service le plus utilisé"
        description="Par volume de transactions, pas par valeur."
        empty={!topByVolume || topByVolume.volume === 0}
        value={topByVolume?.label}
        detail={topByVolume ? formatTransactionCount(topByVolume.volume) : undefined}
      />
      <ServiceHighlightCard
        title="Service générant le plus de gain"
        description="Par valeur (gain), pas par volume."
        empty={!topByGain || topByGain.gain === 0}
        value={topByGain?.label}
        detail={topByGain ? formatXaf(topByGain.gain) : undefined}
        tone="gold"
      />
    </div>
  );
}
